import { gql } from '@apollo/client';

export const USER_PREFERENCES = gql`
  mutation SetUserPreferences($defaultRegions: [String!]!) {
    setUserPreferences(input: { defaultRegions: $defaultRegions }) {
      vendorType
      regions
    }
  }
`;
